import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const TullamarinePage = () => <LocationTemplate suburbName="Tullamarine" suburbSlug="tullamarine" />;

export default TullamarinePage;
